/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum RegistrationOrderStatus {
    WAITLIST = 'waitlist',
    CANCELED = 'canceled',
    PAYMENT_FAILED = 'payment_failed',
    OVERDUE = 'overdue',
    PAID = 'paid',
    SCHEDULED = 'scheduled',
}
